import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

dayjs.extend(duration);

/**
 * Formats a duration in milliseconds to a human-readable format
 * - Less than 1 minute: shows seconds with 3 decimal places (e.g., "1.001s")
 * - 1 minute to 1 hour: shows whole minutes (e.g., "5 min")
 * - 1 hour to 1 day: shows whole hours (e.g., "2 hrs")
 * - 1 day or more: shows whole days (e.g., "3 days")
 *
 * @param milliseconds - Duration in milliseconds
 * @returns Formatted string
 */
export function formatDuration(milliseconds: number): string {
	const dur = dayjs.duration(milliseconds);

	const days = Math.floor(dur.asDays());
	const hours = Math.floor(dur.asHours());
	const minutes = Math.floor(dur.asMinutes());
	const seconds = dur.asSeconds();

	if (days >= 1) {
		return `${days} ${days === 1 ? 'day' : 'days'}`;
	} else if (hours >= 1) {
		return `${hours} ${hours === 1 ? 'hr' : 'hrs'}`;
	} else if (minutes >= 1) {
		return `${minutes} ${minutes === 1 ? 'min' : 'mins'}`;
	} else {
		return `${seconds.toFixed(3)}s`;
	}
}
